export default __webpack_public_path__ + "static/media/About.3d42523a.jpg";